module.exports = __webpack_public_path__ + "static/forecrb2beticaret-1fbcb1edd4355d364bdba47e3328730e.png";